import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, Users, FileText, GraduationCap, LogOut, KeyRound } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BRAND } from "../../data/content";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, roles: ["admin", "manager", "staff"] },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox, roles: ["admin", "manager", "staff"] },
  { to: "/admin/users", label: "Users", icon: Users, roles: ["admin"] },
  { to: "/admin/blog", label: "Compliance Hub", icon: FileText, roles: ["admin"] },
  { to: "/admin/training", label: "Training", icon: GraduationCap, roles: ["admin", "manager"] },
  { to: "/staff", label: "Staff Portal", icon: GraduationCap, roles: ["staff", "manager", "admin"] },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const items = NAV.filter((n) => n.roles.includes(user?.role));

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#0A0F1C] text-white flex flex-col fixed inset-y-0 left-0 z-40">
        <Link to="/" className="p-6 border-b border-white/10 flex items-center" data-testid="admin-logo">
          <div className="bg-white px-3 py-2 rounded-sm w-full">
            <img src={BRAND.logo} alt="OEC" className="h-8 w-auto" />
          </div>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {items.map((n) => (
            <NavLink
              key={n.to} to={n.to} end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-white/10 text-white border-l-2 border-[#3FBAB0]" : "text-white/60 hover:text-white hover:bg-white/5"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="px-3 py-2">
            <p className="text-xs text-white/50">Signed in as</p>
            <p className="text-sm text-white truncate" data-testid="admin-user-name">{user?.name}</p>
            <p className="text-xs text-[#3FBAB0] uppercase tracking-wider mt-1">{user?.role}</p>
          </div>
          <Link to="/admin/change-password" className="mt-2 w-full flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors" data-testid="admin-change-password">
            <KeyRound className="w-4 h-4" /> Change password
          </Link>
          <button onClick={handleLogout} className="mt-1 w-full flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64">
        <Outlet />
      </main>
    </div>
  );
}
